<script>
    export let onConfirm;
</script>

<div class="main-container">
    <div class="logo-container">
        <img src="/imgs/behumane.gif" alt="Logo" class="logo" /> <!-- Replace with your actual logo path -->
    </div>
    <h2>Welcome to Be Human(e) Universe</h2>
    <div class="captcha">
        <button on:click={onConfirm} class="image-button">
            <img src="/imgs/recaptcha.jpg" alt="I'm not a robot" class="captcha-image" />
        </button>
    </div>
</div>

<style>
    .main-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100vh;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        background-color: #f7f9fc;
        color: #333;
        text-align: center;
    }

    .logo-container {
        width: 100%; /* full width of the container */
        max-width: 400px; /* maximum logo width */
        margin-bottom: 1em; /* space below the logo */
    }

    .logo {
        width: 100%; /* responsive width */
        height: auto; /* maintain aspect ratio */
    }

    h2 {
        font-size: 2em;
        margin-bottom: 0.5em;
        color: #4a90e2;
    }

    .captcha {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    button {
        padding: 0.5em 1.5em;
        font-size: 1em;
        cursor: pointer;
        border: 1px solid #d3d3d3;
        border-radius: 4px;
        background-color: #f7f9fc;
        color: #333;
        display: flex;
        align-items: center;
        gap: 10px;
        transition: box-shadow 0.3s;

        &:hover {
            box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
        }
    }

    .image-button {
        border: none;
        background: none;
        padding: 0;
        cursor: pointer;
    }

    .captcha-image {
        height: 100px; /* Example height, adjust as needed */
        width: auto;
    }
</style>